// extracted by mini-css-extract-plugin
export default {"table__container":"styles_table__container__KU6BB"};